/*
 * Mensagem de erro pronta para exibir ao candidato.
 *
 * O back responde 400/401/403 com um texto simples no corpo (o `features/async.js`
 * rejeita a promise com esse texto); erros 500 podem trazer um objeto com
 * `mensagem` (uma etapa futura do back torna esse texto genérico). Qualquer
 * outro formato — HTML de erro de servidor, objeto sem mensagem, nulo — cai no
 * texto padrão da tela.
 */
export const mensagemDoErro = (erro, textoPadrao) => {
    if (typeof erro === 'string') {
        const texto = erro.trim();
        return (texto && !texto.startsWith('<')) ? texto : textoPadrao;
    }

    if (erro && typeof erro === 'object' && typeof erro.mensagem === 'string' && erro.mensagem.trim()) {
        return erro.mensagem;
    }

    return textoPadrao;
};
